import { DocumentNode, gql } from '@apollo/client';
import { Box, Flex, LinkBox, LinkOverlay, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { sponsor_content_clicked } from '@/analytics';
import { FollowButton } from '@/components/FollowButton';
import { OrganizationProfileImage } from '@/components/OrganizationProfileImage';

import { SponsorsList_OrganzationFragment } from './graphql-types/SponsorsList_OrganzationFragment';

const ORGANIZATION_FRAGMENT = gql`
  fragment SponsorsList_OrganzationFragment on Organization {
    _id
    name
    ...OrganizationProfileImage_OrganizationFragment
  }
  ${OrganizationProfileImage.organizationFragment}
`;

export const SponsorsList: React.FC<{
  sponsors: SponsorsList_OrganzationFragment[];
}> & {
  organizationFragment: DocumentNode;
} = (props) => {
  return (
    <>
      {props.sponsors.map((sponsor) => {
        return (
          <Box key={sponsor._id} pt="4">
            <LinkBox w="full">
              <Flex alignItems="center" color="gray.600">
                <OrganizationProfileImage
                  organization={sponsor}
                  h={20}
                  w={20}
                  flexShrink="0"
                />
                <Box flexGrow="1" pl="2" pr="4">
                  <LinkOverlay
                    as={NextLink}
                    href={`/sponsors/${sponsor._id}/overview`}
                    onClick={() => {
                      sponsor_content_clicked({
                        sponsor_id: sponsor._id,
                        sponsor_name: sponsor.name,
                        sponsor_content_type: 'recently_added_card',
                        sponsor_content_id: sponsor._id,
                        sponsor_interaction_source: 'home_feed',
                        location_organization_id: sponsor._id,
                      });
                    }}
                  >
                    <Text
                      textStyle="xlBodyStrong"
                      color="gray.700"
                      noOfLines={2}
                    >
                      {sponsor.name}
                    </Text>
                  </LinkOverlay>
                </Box>
                <FollowButton organizationId={sponsor._id} />
              </Flex>
            </LinkBox>
          </Box>
        );
      })}
    </>
  );
};

SponsorsList.organizationFragment = ORGANIZATION_FRAGMENT;
